


































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { IAddChannel, IChannel } from "@/@types/channels/channels";
import { IContentType } from "@/@types/channels/content-type";
import { channelTypes } from "@/config/channels/channel-types.config.json";

import BSwitch from "../../app/switchs/b-switch.vue";

import {
  required,
  ipAddress,
  numeric,
  maxLength,
  minValue,
} from "vuelidate/lib/validators";
import {
  ipBroadcastTypes,
  languages,
  channelType,
} from "@/config/channels/channel-types.config.json";

@Component({
  components: {
    BSwitch,
  },
  mixins: [validationMixin],
  validations: {
    ip: { required, ipAddress },
    port: { required, numeric, maxLength: maxLength(6), minValue: minValue(0) },
    name: { required, maxLength: maxLength(100) },
    ipBroadcastType: { required },
    sortOrder: { numeric, minValue: minValue(0) },
    language: {},
    contentType: {},
  },
})
export default class AddChannelFromIP extends Vue {
  @Prop({ type: Object, default: null }) channel!: IChannel;
  @Prop({ type: Array, default: () => [] }) contentTypes!: IContentType[];
  @Prop({ type: String, default: null }) formType!: string;
  @Prop({ type: String, default: "tv" }) activeType!: string;

  ip = "";
  name = "";
  port: number | null = null;
  ipBroadcastType = ipBroadcastTypes[1].id;
  sortOrder = 0;
  language = "";
  contentType = "";
  posterName = "";
  showChannel = false;
  selectedChannelType = channelType[2].id;
  logicalNumberOnLinkedTv: number | null = null;

  ipBroadcastTypes = ipBroadcastTypes;
  languages = languages;

  get ipBroadcastTypeName(): string {
    const type = this.ipBroadcastTypes.find(
      (el) => el.id == this.ipBroadcastType
    );
    return type
      ? `${type.name}: ${type.id}`
      : String(this.$i18n.t("ChannelsPage.form.ipBroadcastType.no-type"));
  }

  get channelLanguage(): string {
    const language = this.languages.find((l) => l.lang == this.language);
    return language
      ? language.name
      : String(this.$i18n.t("ChannelsPage.form.langusge.no-type"));
  }

  get contentTypeName(): string {
    const type = this.contentTypes.find((el) => el._id == this.contentType);
    return type
      ? this.$getLocale(type.name)
      : String(this.$i18n.t("ChannelsPage.form.contentType.no-type"));
  }

  get type(): number {
    const i = channelTypes.findIndex((t) => t == this.activeType);
    return i < 0 ? 1 : i + 1;
  }

  get ch(): Partial<IAddChannel> {
    return {
      _id: this.channel ? this.channel._id : "",
      data: {
        channelType: this.selectedChannelType,
        ip: this.ip,
        port: this.port ? this.port : 0,
        ipBroadcastType: this.ipBroadcastType,
      },
      image: this.posterName,
      name: this.name,
      show: this.showChannel,
      sort_order: this.sortOrder,
      language: this.language,
      type: this.channel ? this.channel.type : this.type,
      content_type: this.contentType,
      logical_number_on_linked_tv: this.logicalNumberOnLinkedTv ?? 0,
    };
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");
      this.$v.$touch();
      return;
    }

    this.$emit("update", this.ch);
  }

  onReset(): void {
    this.ip = "";
    this.port = 0;
    this.name = "";
    this.ipBroadcastType = ipBroadcastTypes[1].id;
    this.sortOrder = 0;
    this.language = "";
    this.contentType = "";
    this.posterName = "";
    this.showChannel = false;
    this.selectedChannelType = channelType[2].id;
    this.logicalNumberOnLinkedTv = null;
  }

  @Watch("channel")
  valueDistribution(): void {
    if (!this.channel || !this.channel.data) return;
    this.ip = this.channel.data.ip ? this.channel.data.ip : "";
    this.port = this.channel.data.port ? this.channel.data.port : null;
    this.name = this.channel.name;
    this.ipBroadcastType = this.channel.data.ipBroadcastType
      ? this.channel.data.ipBroadcastType
      : ipBroadcastTypes[1].id;
    this.sortOrder = this.channel.sort_order;
    this.language = this.channel.language;
    this.contentType = this.channel.content_type;
    this.posterName = this.channel.image;
    this.showChannel = this.channel.show;
    this.logicalNumberOnLinkedTv =
      this.channel.logical_number_on_linked_tv ?? null;
  }

  @Watch("name")
  @Watch("posterName")
  updateDemo(): void {
    this.$emit("updateDemo", this.name, this.posterName);
  }

  mounted(): void {
    this.valueDistribution();
  }
}
